import { render, staticRenderFns } from "./ClasificacionPqr.vue?vue&type=template&id=39655f99&scoped=true"
import script from "./ClasificacionPqr.vue?vue&type=script&lang=js"
export * from "./ClasificacionPqr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39655f99",
  null
  
)

export default component.exports